import axios from 'axios';
import { checkAndHandleAuthError } from './authErrorHandler';

// Add a response interceptor to handle authentication errors globally
axios.interceptors.response.use(
    (response) => {
        // Check for authentication errors in successful responses (status 200)
        checkAndHandleAuthError(response.data);
        return response;
    },
    (error) => {
        // Handle error responses
        if (error.response) {
            // Check for authentication errors in error responses
            checkAndHandleAuthError(error.response.data);

            // Also check for 401 status code
            if (error.response.status === 401) {
                const errorMessage = error.response.data?.message || 'Your session has expired. Please login again.';
                localStorage.setItem('auth-error-message', errorMessage);
                localStorage.setItem('auth-redirect-pending', 'true');
                localStorage.removeItem('token-afrisocialworld');
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

export default axios;
